import { Grid } from '@material-ui/core';
import { TextField, Typography } from '@nutrien/cxp-components';
import React, { useEffect, useState } from 'react';

import { deficiencyAction } from '../../models/models';
import { DeficiencyActionedList } from '../../rxdb/deficiencyActionedList/queryBuilder';
import { generateActionsList } from '../../utilities/utilityFunctions';
import useStyles from './DeficiencyAction.styles';

interface Props {
  deficiencyActionedList: DeficiencyActionedList;
  isEditable: boolean;
}

const DeficiencyActionPanel: React.FC<Props> = ({ deficiencyActionedList, isEditable }) => {
  const classes = useStyles();
  const [actionsList, setActionsList] = useState<deficiencyAction[]>([]);

  useEffect(() => {
    if (deficiencyActionedList) {
      setActionsList(generateActionsList(deficiencyActionedList));
    }
  }, [deficiencyActionedList]);

  return (
    <>
      {actionsList.some(action => action.actionId) && (
        <Grid className={classes.outerGrid} xs={12} item container>
          <Grid container spacing={2}>
            <Grid item container xs={12} alignItems="center">
              <Grid item xs={12} className={classes.deficiencyActionGrid}>
                <Typography variant="h6">Action</Typography>
                <hr className={`${classes.breakLine} ${classes.checkboxLabel}`} />
              </Grid>
              <Grid item xs={12} className={classes.actionTypeGrid}>
                <Grid item xs={6}>
                  <Typography variant="subtitle2" className="fieldLabel">
                    <span>Action Type</span>
                  </Typography>
                  {actionsList.map(
                    action =>
                      action.actionId && (
                        <TextField
                          name={action.actionType}
                          className={`${classes.firstAutoComplete} ${classes.textFieldHeight} ${classes.textMargin}`}
                          defaultValue={action.actionType}
                          disabled={!isEditable}
                          placeholder={action.actionType}
                          noMinHeight
                          size="small"
                        />
                      ),
                  )}
                </Grid>
                <Grid item xs={1} />
                <Grid item xs={6}>
                  <Typography variant="subtitle2" className="fieldLabel">
                    <span>Action ID - Action Status</span>
                  </Typography>
                  {actionsList.map(
                    action =>
                      action.actionId && (
                        <TextField
                          name={action.actionStatus}
                          className={`${classes.firstAutoComplete} ${classes.textFieldHeight} ${classes.textMargin}`}
                          defaultValue={`${action.actionId}${
                            action.actionStatus ? ` - ${action.actionStatus}` : ''
                          }`}
                          disabled={!isEditable}
                          placeholder={`${action.actionId}${
                            action.actionStatus ? ` - ${action.actionStatus}` : ''
                          }`}
                          noMinHeight
                          size="small"
                        />
                      ),
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default DeficiencyActionPanel;
